import { $http, readCookie } from "@/assets/js/appFunc";

export const getUserDetails = (store) => {
    $http({
        url: "/identity/tenants/users/profile",
        type: "GET",
        data: ""
    }, true).then(rsp => {
        store.commit("setUserDetails", rsp.data);
    }).catch(() => {
        // TODO error handling
    });
};

export const getUsersList = (store) => new Promise((resolve, reject) => {
    $http({
        url: "/identity/tenants/users",
        type: "GET"
    }, true).then(rsp => {
        store.commit("setUserListDelegation", rsp.data);
        resolve(rsp);
    }).catch(e => {
        reject(e);
    });
});

export const saveDelegation = (store, data) => new Promise((resolve, reject) => {
    $http({
        url: "/engine/api/delegation/save",
        type: "POST",
        data
    }, true).then(rsp => {
        resolve(rsp);
    }).catch(e => {
        reject(e);
    });
});

export const getUsersForDelegation = (store, data) => new Promise((resolve, reject) => {
    $http({
        url: "/identity/tenants/users/delegation",
        type: "POST",
        data
    }, true).then(rsp => {
        resolve(rsp.data);
    },
    error => {
        reject(error);
        console.log(error);
    });
});

export const cancelDelegation = (context) => new Promise((resolve, reject) => {
    const { delegationId } = context.rootState.userProfile;
    $http({
        url: `/engine/api/delegation/cancel/delegationId/${delegationId}`,
        type: "POST"
    }, true).then(rsp => {
        resolve(rsp.data);
    },
    error => {
        reject(error);
        console.log(error);
    });
});

export const getDelegation = (context, userId) => {
    const params = {
        type: "GET",
        url: `/engine/api/delegation/list/userId/${userId}`
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                context.commit("setDelegationId", data.data);
                resolve(data.data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const actDelegationsForUser = (context, userId) => {
    const req = {
        type: "GET",
        url: `/engine/api/delegations/for/delegate/userId/${userId}`
    };
    return $http(req, true);
};

export const actAcceptRejectDelegation = (context, delegation) => {
    const req = {
        type: "POST",
        url: `/engine/api/delegation/${delegation.id}/update/status?status=${delegation.status}`
    };
    return $http(req, true);
};

export const getNotificationsSettings = (store) => {
    $http({
        url: "/identity/tenants/users/profile/notification",
        type: "GET",
        data: ""
    }, true).then(rsp => {
        store.commit("setNotificationsSettings", rsp.data);
    }).catch(() => {
        // TODO error handling
    });
};

export const getMyRoles = (store) => {
    $http({
        url: "/identity/tenants/users/profile/roles",
        type: "GET",
        data: ""
    }, true).then(rsp => {
        store.commit("setMyRoles", rsp.data);
    }).catch(() => {
        // TODO error handling
    });
};

export const saveUserProfile = (store, data) => {
    const req = {
        type: "POST",
        url: "/identity/tenants/users/profile",
        data: data.formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            rsp => {
                if (data.changeSubmit) {
                    store.commit("updateUserDetails", data.localData);
                }
                resolve(rsp);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const saveNotificationsSettings = (store, data) => $http({
    url: "/identity/tenants/users/profile/notification",
    type: "POST",
    data
}, true);

export const checkOldPassword = (context, payload) => {
    const req = {
        type: "POST",
        url: `/identity/tenants/checkPassword/${
            context.rootGetters["userProfile/getUserName"]
        }`,
        data: payload,
        noNotify: true
    };
    return $http(req, true);
};

export const saveCookieInfo = (store) => {
    const timestampCookie = readCookie("timestamp");

    // if timestamp is the same, do nothing
    if (timestampCookie === store.rootGetters["userProfile/timestampCookie"]) {
        return;
    }

    const cookie = readCookie("jwt1");
    let cookieData = "";
    if (cookie) {
        let base64 = cookie.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        const padding = base64.length % 4;
        if (padding) {
            base64 += "=".repeat(4 - padding);
        }
        cookieData = atob(base64);
    }

    if (cookieData) {
        cookieData = JSON.parse(cookieData);

        store.commit("userCookieInfo", cookieData);
        store.commit("timestampCookie", timestampCookie);
    }
};

export const cookieRefreshDummy = () => {
    $http({
        url: "/engine/dashboard/cookie/refresh",
        type: "GET",
        data: ""
    }, true).then(() => {
    }).catch(() => {
    });
};

export const refreshPrincipal = () => $http({
    url: "/auth/refresh-principal",
    type: "GET",
    data: ""
}, true);
